var Component = require("!../../../../../../develop/node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../../develop/node_modules/vue-loader/lib/selector?type=script&index=0!./BlackForm.vue"),
  /* template */
  require("!!../../../../../../develop/node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-56aeda59\",\"hasScoped\":false}!../../../../../../develop/node_modules/vue-loader/lib/selector?type=template&index=0!./BlackForm.vue"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/pages/BlackForm.vue
// module id = 398
// module chunks = 0